module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg5NiAxNjBhNjQgNjQgMCAwIDEgNjQgNjR2NTEyYTY0IDY0IDAgMCAxLTY0IDY0aC0yODhsLTczLjQgNzMuNGEzMiAzMiAwIDAgMS00NS4yIDBMNDE2IDgwMEgxMjhhNjQgNjQgMCAwIDEtNjQtNjRWMjI0YTY0IDY0IDAgMCAxIDY0LTY0aDc2OHpNMzA0IDQxNmE0OCA0OCAwIDEgMCAwIDk2IDQ4IDQ4IDAgMCAwIDAtOTZ6IG0yMjQgMGE0OCA0OCAwIDEgMCAwIDk2IDQ4IDQ4IDAgMCAwIDAtOTZ6IG0yMjQgMGE0OCA0OCAwIDEgMCAwIDk2IDQ4IDQ4IDAgMCAwIDAtOTZ6IiBmaWxsPSIjMCIgcC1pZD0iMzQyNSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Chat-filled.svg
// module id = valB
// module chunks = 73